module.exports = __webpack_public_path__ + "static/cp-feature-1-7d5d19660ce2f9b1774701a0175a977e.png";